import Grid from "@mui/material/Grid";
import { WorkoutPlan } from "../../../../service/model/workout.model";
import useExercises from "../../../../hooks/use-exercises";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { selectActivePlan, updateActivePlan } from "../workout-plan.slice";
import WorkoutCard from "./workout-card";

interface WorkoutDayProps {
    dayIndex: number;
}

const WorkoutDay: React.FC<WorkoutDayProps> = ({ dayIndex }) => {
    const dispatch = useAppDispatch();
    const activePlan = useAppSelector(selectActivePlan);
    // const exercises = activePlan?.workoutDays[dayIndex]?.exercises || [];
    const [exerciseItems] = useExercises();

    // dialog state
    // const [isDialogOpen, setIsDialogOpen] = useState(false);
    // const [newExerciseName, setNewExerciseName] = useState("");

    // const handleAddExercise = (exercise: Exercise, sets: number, reps: number) => {
    //     const newExercise: WorkoutDayExercise = {
    //         orderIndex: exercises.length,
    //         exercise: exercise,
    //         reps: reps,
    //         sets: sets

    //     };
    //     dispatch(updateActivePlan({
    //         ...activePlan,
    //         workoutDays: activePlan?.workoutDays?.map((day, index) =>
    //             index === dayIndex
    //                 ? { ...day, exercises: [...(day.exercises || []), newExercise] }
    //                 : day
    //         )
    //     } as WorkoutPlan));
    // };

    // const openDialog = () => {
    //     setNewExerciseName("");
    //     setIsDialogOpen(true);
    // };

    // const closeDialog = () => {
    //     setIsDialogOpen(false);
    // };

    // const confirmAddExercise = () => {
    //     if (newExerciseName.trim()) {
    //         handleAddExercise(newExerciseName.trim(), 5, 10);
    //     }
    //     closeDialog();
    // };


    return (
        <>
            {/* <Typography variant="h5">Exercises</Typography> */}
            <Grid container direction="row" justifyContent="flex-start" spacing={2}>

                <Grid size={{ xs: 12 }} sx={{ display: "flex", flexDirection: "column" }}>
                    <WorkoutCard
                        workoutDayExercises={activePlan?.workoutDays?.[dayIndex]?.exercises || []}
                        exercises={exerciseItems}
                        onExercisesChange={(exercises) => {
                            dispatch(updateActivePlan({
                                ...activePlan,
                                workoutDays: activePlan?.workoutDays?.map((day, index) =>
                                    index === dayIndex
                                        ? { ...day, exercises: exercises }
                                        : day
                                )
                            } as WorkoutPlan));
                        }}
                    />
                </Grid>
            </Grid>

            {/* <Dialog open={isDialogOpen} onClose={closeDialog}>
                <DialogTitle>Add Exercise</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Exercise name"
                        fullWidth
                        value={newExerciseName}
                        onChange={(e) => setNewExerciseName(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') confirmAddExercise();
                        }}
                    />

                    <Divider sx={{ my: 2 }} />
                    <Typography variant="body2" color="textSecondary">
                        Please enter a name for the exercise or select frequently used one from below list.
                    </Typography>
                    {["Breakfast", "Lunch", "Dinner", "Snack", "Pre-Workout", "Post-Workout"].map((exerciseName) => (
                        <StyledChip
                            key={exerciseName}
                            onClick={() => {
                                setNewExerciseName(exerciseName);
                            }}
                            label={exerciseName}
                            sx={{ mt: 1, mr: 1, cursor: "pointer" }}
                        />
                    ))}
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeDialog} variant="contained" sx={{ bgcolor: `${theme.palette.secondary.main}` }}>Cancel</Button>
                    <Button onClick={confirmAddExercise} variant="contained" sx={{ bgcolor: `${theme.palette.primary.main}` }}>Save</Button>
                </DialogActions>
            </Dialog> */}
        </>

    );
};

export default WorkoutDay;
